<style lang="scss" src="./Navigation.scss"></style>
<script lang="ts" src="./Navigation.ts"></script>

<template>
  <div class="navigation-qlist">
    <!-- Standalone items (no subnodes) -->
    <q-item v-for="item in filteredList.filter(i => (i.subnodes ?? []).length === 0)" :key="item.id"
      :class="{ active: item.isActive }" clickable @click="handleStandaloneClick(item)" role="menuitem"
      :aria-label="item.node" :aria-current="item.isActive ? 'page' : undefined">
      <q-item-section avatar>
        <font-awesome-icon v-if="item.iconClass && item.iconClass.length > 0" :icon="item.iconClass" size="lg"
          class="width-24" />
        <q-img v-else-if="item.iconImage && item.iconImage.length > 0" :src="getIconSource(item.iconImage)"
          :error-src="getIconSource('dashboard-icon.svg')" class="icon-image" loading="lazy" />
      </q-item-section>

      <q-item-section>
        <router-link :to="item.path" :class="item.isActive ? 'text-body-bold' : 'text-body-semi-bold'">
          {{ item.node }}
        </router-link>
      </q-item-section>
    </q-item>

    <!-- Parent items with subnodes -->
    <q-expansion-item v-for="item in filteredList.filter(i => (i.subnodes ?? []).length > 0)" :key="item.id"
      :label="item.node" v-model="item.isActive" expand-icon="keyboard_arrow_down" collapse-icon="keyboard_arrow_up"
      group="navigation-group" :class="[item.isActive ? 'active' : '']" @click="handleHeaderClick(item)" role="menuitem"
      :aria-label="item.node" :aria-expanded="item.isActive" :aria-current="item.isActive ? 'page' : undefined">
      <template #header>
        <q-item-section avatar>
          <font-awesome-icon v-if="item.iconClass && item.iconClass.length > 0" :icon="item.iconClass" size="lg"
            class="width-24" />
          <q-img v-else-if="item.iconImage && item.iconImage.length > 0" :src="getIconSource(item.iconImage)"
            :error-src="getIconSource('dashboard-icon.svg')" class="icon-image" loading="lazy" />
        </q-item-section>

        <span :class="item.isActive ? 'text-body-bold' : 'text-body-semi-bold'" @click="handleHeaderClick(item)">
          {{ item.node }}
        </span>
      </template>

      <q-card v-for="subItem in item.subnodes" :key="subItem.id"
        :class="{ active: firstTwoSegmentsMatch(route.path, subItem.path) }">
        <q-card-section v-if="isSubnodeVisible(subItem)">
          <a v-if="isExternalRouteSubnode(subItem, item.node)" href="#"
            @click="handleSubnodeClick(subItem, item.node, $event)">
            {{ subItem.node }}
          </a>
          <router-link v-else :to="subItem.path"
            :class="firstTwoSegmentsMatch(route.path, subItem.path) ? 'text-body-bold' : 'text-body-semi-bold'"
            role="menuitem" :aria-label="subItem.node"
            :aria-current="firstTwoSegmentsMatch(route.path, subItem.path) ? 'page' : undefined">{{ subItem.node
            }}</router-link>
        </q-card-section>
      </q-card>
    </q-expansion-item>
  </div>
</template>
